import React, { useState } from "react";
import Divider from "@mui/material/Divider";
import ClearIcon from "@mui/icons-material/Clear";
import SaveIcon from "@mui/icons-material/Save";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import MenuItem from "@mui/material/MenuItem";
import InputAdornment from "@mui/material/InputAdornment";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import IconButton from "@mui/material/IconButton";
import { v4 as uuidv4 } from "uuid";

import { ROLES } from "../../../utils/constants";

const UserForm = (props) => {
  const [showPassword, setShowPassword] = useState(false);

  const save = () => {
    const USER_NAME_TAKEN = props.users.some(
      (user) =>
        user.UserName === props.user.UserName && user.Id !== props.user.Id
    );
    if (!USER_NAME_TAKEN) {
      props.save();
    } else {
      props.enqueueSnackbar(`ERROR : username taken`, {
        preventDuplicate: true,
        variant: "warning",
      });
    }
  };

  return (
    <Dialog open={true} onClose={props.handleClose}>
      <DialogTitle>{props.edit ? "Edit User" : "Add User"}</DialogTitle>

      <DialogContent>
        <Grid container spacing={2}>
          {props.branches.length && (
            <Grid item xs={4}>
              <TextField
                select
                fullWidth
                margin="dense"
                name="Branch"
                label="Branch"
                type="text"
                helperText="User branch"
                value={
                  props.user.Branch
                    ? props.user.Branch
                    : props.branches[0].Prefix
                }
                onChange={props.handleChange}
              >
                {props.branches.map((branch) => (
                  <MenuItem key={uuidv4()} value={branch.Prefix}>
                    {branch.Prefix}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
          )}

          <Grid item xs={8}>
            <TextField
              select
              fullWidth
              name="Role"
              label="Role"
              value={props.user.Role ? props.user.Role : ROLES[0]}
              margin="dense"
              variant="outlined"
              helperText="Please select the user's role"
              onChange={props.handleChange}
            >
              {ROLES.map((role) => (
                <MenuItem key={uuidv4()} value={role}>
                  {role}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
        </Grid>

        <Grid container spacing={2}>
          <Grid item xs={6}>
            <TextField
              name="FirstName"
              margin="dense"
              label="First name"
              type="text"
              fullWidth
              value={props.user.FirstName ? props.user.FirstName : ""}
              onChange={props.handleChange}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              margin="dense"
              name="LastName"
              label="Last Name"
              type="text"
              fullWidth
              value={props.user.LastName ? props.user.LastName : ""}
              onChange={props.handleChange}
            />
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              margin="dense"
              name="UserName"
              label="Username/Email"
              type="text"
              fullWidth
              value={props.user.UserName ? props.user.UserName : ""}
              onChange={props.handleChange}
            />
          </Grid>
        </Grid>

        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              name="Password"
              margin="dense"
              label="Password"
              type={showPassword ? "text" : "password"}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => setShowPassword(!showPassword)}
                      onMouseDown={(event) => event.preventDefault()}
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              fullWidth
              value={props.user.Password ? props.user.Password : ""}
              onChange={props.handleChange}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <Divider />
      <DialogActions>
        <Stack
          direction="row"
          justifyContent="flex-end"
          alignItems="flex-start"
          spacing={2}
        >
          <Button
            variant="outlined"
            onClick={props.close}
            color="primary"
            size="large"
            startIcon={<ClearIcon />}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={save}
            color="secondary"
            size="large"
            startIcon={<SaveIcon />}
          >
            Save
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  );
};

export default UserForm;
